// extracted by mini-css-extract-plugin
export default {"tabletMinWidth":"768","tabletMaxWidthLandscape":"1024","mobileMaxHeight":"480","mobileMaxWidthLandscape":"926","customMaxWidthHeaderActionIcons":"1224"};